import {t} from "i18next";

import AvailabilityStatusCIrcule from "../../../utilities/AvailabilityStatusCIrcule";
import {STATUS_COLORS} from "../../../utilities/colorConstants";
import {COF_STATES} from "../../../utilities/generalConstants.js/generalConstants";

const CO_STATUS_TOOLTIP_BY_COLOR = {
  [STATUS_COLORS.TRANSPARENT]: t("'Bring to' isn't specified for CO"),
  [STATUS_COLORS.RED]: t("CO is expired"),
  [STATUS_COLORS.YELLOW]: t("CO is almost expired"),
  [STATUS_COLORS.GREEN]: t("CO is valid"),
  [STATUS_COLORS.GREY]: t("CO is completed/archived/has directive"),
};

const CO_F_STATUS_TOOLTIP_BY_COLOR = {
  [STATUS_COLORS.RED]: t("CO(f) is expired"),
  [STATUS_COLORS.YELLOW]: t("CO(f) is almost expired"),
  [STATUS_COLORS.GREEN]: t("CO(f) is valid"),
  [STATUS_COLORS.GREY]: t("CO(f) is fully paid"),
};

export const getManagerOptions = arr =>
  arr?.map(v => ({
    title: v.name,
    value: v.userId,
  })) || [];

export const KP_LIST_TABLE_COLUMNS = Object.freeze([
  {
    header: "Status.",
    accessorKey: "status",
    size: 40,
    maxSize: 40,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}} title="">
        <AvailabilityStatusCIrcule
          color={circleColor.getValue()}
          tooltipMessage={CO_STATUS_TOOLTIP_BY_COLOR[circleColor.getValue()] || ""}
        />
      </div>
    ),
  },
  {
    header: "State",
    accessorKey: "state",
    size: 20,
    maxSize: 25,
    textAlign: "center",
    cell: ({getValue}) => (
      <span
        style={{fontStyle: "normal"}}
        title={
          getValue() === COF_STATES.PAID
            ? t("Has paid directive")
            : getValue() === COF_STATES.HAS_DIRECTIVE
            ? t("Has directive")
            : ""
        }
      >
        {getValue()}
      </span>
    ),
  },
  {
    header: "CO №",
    accessorKey: "coNumber",
    size: 80,
    maxSize: 80,
    isSortable: true,
  },
  {
    header: "Client name",
    accessorKey: "clientName",
    size: 80,
    maxSize: 80,
    isSortable: true,
  },
  {
    header: "Note/desc",
    accessorKey: "note",
    alignStart: true,
    size: 200,
  },
  {
    header: "Date from",
    accessorKey: "startDate",
    size: 70,
    maxSize: 70,
    isSortable: true,
    sortingFn: "sortDate",
  },
  {
    header: "Date to",
    accessorKey: "finalDate",
    size: 70,
    maxSize: 70,
    isSortable: true,
    sortingFn: "sortDate",
  },
  {
    header: "COf custom naming",
    accessorKey: "cofSecondNumber",
    size: 80,
    maxSize: 80,
    isSortable: true,
    sortingFn: "sortString",
  },
  {
    header: "Manager",
    accessorKey: "projectManager",
    size: 90,
    maxSize: 90,
    isSortable: true,
  },
  {
    header: "Manager CO",
    accessorKey: "coManager",
    size: 90,
    maxSize: 90,
    isSortable: true,
  },
]);

export const KP_F_LIST_TABLE_COLUMNS = Object.freeze([
  {
    header: "Status",
    accessorKey: "status",
    size: 40,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
        <AvailabilityStatusCIrcule
          color={circleColor.getValue()}
          tooltipMessage={CO_F_STATUS_TOOLTIP_BY_COLOR[circleColor.getValue()] || ""}
        />
      </div>
    ),
  },
  {
    header: "State",
    accessorKey: "state",
    size: 40,
    textAlign: "center",
    cell: ({getValue}) => (
      <span
        style={{fontStyle: "normal"}}
        title={
          getValue() === COF_STATES.PAID
            ? t("Has paid directive")
            : getValue() === COF_STATES.HAS_DIRECTIVE
            ? t("Has directive")
            : getValue() === COF_STATES.FROZEN
            ? t("freezedForClient")
            : ""
        }
      >
        {getValue()}
      </span>
    ),
  },
  {
    header: "Date state",
    accessorKey: "date",
    // size: 100,
  },
  {
    header: "CO(f) №",
    accessorKey: "cofNumber",
    // size: 100,
  },
  {
    header: "COf amount",
    accessorKey: "cofSum",
    textAlign: "right",
    // size: 100,
  },
  {
    header: "Manager",
    accessorKey: "projectManager",
    size: 120,
    maxSize: 120,
  },
  {
    header: "Manager CO",
    accessorKey: "coManager",
    size: 120,
    maxSize: 120,
  },
  {
    header: "Note/desc",
    accessorKey: "note",
    alignStart: true,
    size: 450,
    enableColumnFilter: true,
    filterFn: "includesString",
  },
  // {
  //   header: "Date from",
  //   accessorKey: "startDate",
  //   // size: 100,
  // },
  // {
  //   header: "Date to",
  //   accessorKey: "finalDate",
  //   // size: 100,
  // },
  // {
  //   header: "Rate",
  //   accessorKey: "rate",
  //   // size: 100,
  // },
  // {
  //   header: "Currency",
  //   accessorKey: "currency",
  //   // size: 100,
  // },
  {
    header: "Person in charge info",
    accessorKey: "clientInfo",
    alignStart: true,
    size: 200,
  },
]);

export const KP_A_LIST_TABLE_COLUMNS = Object.freeze([
  {
    header: "Status",
    accessorKey: "status",
    size: 40,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
        <AvailabilityStatusCIrcule color={circleColor.getValue()} />
      </div>
    ),
  },
  {
    header: "№nn",
    accessorKey: "number",
    size: 25,
  },
  {
    header: "CO(a) №",
    accessorKey: "coaNumber",
    // size: 100,
  },

  {
    header: "Manager",
    accessorKey: "projectManager",
    // size: 100,
  },
  {
    header: "Manager CO",
    accessorKey: "coManager",
    // size: 60,
  },
  {
    header: "Note/desc",
    accessorKey: "note",
    alignStart: true,
    size: 400,
    enableColumnFilter: true,
    filterFn: "includesString",
  },
  {
    header: "Date from",
    accessorKey: "startDate",
    // size: 100,
  },
  {
    header: "Date to",
    accessorKey: "finalDate",
    // size: 100,
  },
]);

export const KP_TO_DO_TABLE_COLUMNS = Object.freeze([
  {
    header: "№nn",
    accessorKey: "number",
    size: 25,
    cell: value => <span className={value.row.original.isDone ? "strikethroughRow" : ""}>{value.getValue()}</span>,
  },
  {
    header: "CO(..)№",
    accessorKey: "coNumber",
    size: 80,
    maxSize: 80,
    cell: value => <span className={value.row.original.isDone ? "strikethroughRow" : ""}>{value.getValue()}</span>,
    // size: 100,
  },
  {
    header: "Notes",
    accessorKey: "note",
    size: 400,
    alignStart: true,
    enableColumnFilter: true,
    filterFn: "includesString",
    cell: value => <span className={value.row.original.isDone ? "strikethroughRow" : ""}>{value.getValue()}</span>,
  },
  {
    header: "D-day",
    accessorKey: "dueDate",
    size: 70,
    maxSize: 70,
    cell: value => <span className={value.row.original.isDone ? "strikethroughRow" : ""}>{value.getValue()}</span>,
    isSortable: true,
    sortingFn: "sortDate",
  },
  {
    header: "Status",
    accessorKey: "status",
    size: 50,
    maxSize: 50,
    // cell: status => (
    //   <div style={{fontStyle: "normal"}}>{status.getValue() === 1 ? "✓" : status.getValue() === 0 ? "⏰" : ""}</div>
    // ),
    cell: circleColor =>
      circleColor.getValue() === "done" ? (
        <div style={{fontStyle: "normal"}}>✓</div>
      ) : (
        <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
          <AvailabilityStatusCIrcule color={circleColor.getValue()} />
        </div>
      ),
    // size: 60,
    isSortable: true,
  },
]);

export const INVOICE_CREATING_TABLE_COLUMNS = Object.freeze([
  {
    header: "Data",
    accessorKey: "data",
    size: 60,
    cell: ({getValue}) => <pre className="longColumnWrap tar m0">{getValue()}</pre>,
  },
  {
    header: "Supplier requisites",
    accessorKey: "sellerDetails",
    cell: ({getValue}) => <pre className="longColumnWrap tar m0">{getValue()}</pre>,
    size: 100,
  },
]);
